export enum NoSaleCategories {
  COMPETITION = 'COMPETITION',
  MISSING_PLANS = 'MISSING_PLANS',
  SPAM = 'SPAM',
  RETIREMENT_COVERAGE = 'RETIREMENT_COVERAGE',
  UNRESPONSIVE = 'UNRESPONSIVE',
  INELIGIBLE_FOR_MEDICARE = 'INELIGIBLE_FOR_MEDICARE',
  STAY_ON_CURRENT_PLAN = 'STAY_ON_CURRENT_PLAN',
}
